import React from 'react';
import './DocsList.scss';
import './DocsList-media.scss';
import Doc from '../Doc/Doc';
import { Props } from './interfaces';

const DocsList = ({ list, grid }: Props) => {
  return (
    <div
      className={`docs-list${grid ? ' docs-list_grid' : ''}`}
      style={grid ? { gridTemplateColumns: `repeat(${grid}, auto)` } : {}}
    >
      {list.map((item, i) => (
        <Doc {...item} key={i} />
      ))}
    </div>
  );
};

export default DocsList;
